import React from 'react';
import { renderIf, isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const BaasicInputTemplate = ({
	t,
	field,
	additionalInfo,
	isDimension,
	reference,
	className,
	placeholder,
	noSpc,
	showCheckmark,
	validation,
	onKeyUp,
	autoComplete,
	key,
	autoFocus,
	disabled,
	iconClass,
	innerClassName,
	inputClassName,
	onIconClick,
	customMessage,
	labelAddon,
}) => {
	let selector = '';
	if (field != null) {
		selector = `${field.name}-input`;
	}
	const showCheckmarkValue = isSome(showCheckmark) ? showCheckmark : true;
	const validate = isSome(validation) ? validation : true;
	const requiredMark =
		field.rules && field.rules.indexOf('required') !== -1 ? <span className="type--color--warning">*</span> : null;
	const onBlurDefault = event => {
		// Default behavior of onBlur event is to trim whitespaces of input field.
		if (field != null && field.value != null) {
			field.value = field.value.trim();
			event.target.value = field.value;
		}
	};
	return (
		<div className={`${noSpc ? '' : 'spc--bottom--sml'} ${className}`}>
			<div className='flex--primary'>
				<label
					htmlFor={field.id}
					data-cy={selector != '' ? selector + '-label' : undefined}
					className="form__label--required"
				>
					{`${t(field.label)}${isSome(additionalInfo) ? additionalInfo : ''}`} {requiredMark}
				</label>
				<label className='spc--left--auto'>{labelAddon}</label>
			</div>
			{renderIf(isSome(field.error) && validate)(<p className="type--tny type--color--error">{t(field.error)}</p>)}
			<div className={`pos--rel ${innerClassName}`}>
				<input
					ref={
						reference
							? input => {
									reference(input, field);
							  }
							: null
					}
					data-cy={selector != '' ? selector : undefined}
					className={
						isSome(field.error) && validation
							? 'input input--med input--invalid'
							: showCheckmarkValue &&
							  field.$rules &&
							  field.$rules.includes('required') &&
							  !isSome(field.error) &&
							  field.$value
							? 'input input--med input__wrap--valid'
							: `input input--med ${inputClassName}`
					}
					{...field.bind()}
					key={key}
					autoFocus={autoFocus}
					autoComplete={autoComplete}
					placeholder={placeholder}
					onKeyUp={onKeyUp}
					onBlur={onBlurDefault}
					disabled={disabled}
				/>
				{customMessage && <label>{customMessage}</label>}
				{renderIf(
					showCheckmarkValue &&
						field.$rules &&
						field.$rules.includes('required') &&
						!isSome(field.error) &&
						field.$value
				)(
					<span className="form__label--check type--color--success">
						<i className="fa fa-check-circle"></i>
					</span>
				)}
				{iconClass && <i className={iconClass} onClick={onIconClick}></i>}
			</div>
			{isDimension}
		</div>
	);
};

export default defaultTemplate(BaasicInputTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/forms/BaasicInputTemplate.js